import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useCart } from "@/context/CartContext";

export const Nav = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled ? "border-b border-ink/10 bg-bone/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 md:h-20 md:px-10">
        <Link to="/" data-testid="nav-logo-link" className="text-ink">
          <Logo />
        </Link>
        <div className="hidden items-center gap-10 text-[13px] uppercase tracking-[0.18em] md:flex">
          <a href="/#collection" data-testid="nav-collection-link" className="link-underline">Collection</a>
          <a href="/#finishes" data-testid="nav-finishes-link" className="link-underline">Finishes</a>
          <a href="/#craft" data-testid="nav-craft-link" className="link-underline">Craft</a>
        </div>
        <button
          data-testid="nav-cart-button"
          onClick={() => setOpen(true)}
          className="group flex items-center gap-2.5 rounded-full border border-ink/20 px-4 py-2 text-[13px] uppercase tracking-[0.16em] transition-colors duration-300 hover:bg-ink hover:text-bone"
        >
          <ShoppingBag className="h-4 w-4" strokeWidth={1.5} />
          <span>Bag</span>
          <span data-testid="nav-cart-count" className="grid h-5 min-w-5 place-items-center rounded-full bg-clay px-1.5 text-[11px] text-white">
            {count}
          </span>
        </button>
      </nav>
    </header>
  );
};
